import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleCalendarDay } from 'src/app/shared/models/shift-management/schedule-calendar-day.model';

@Pipe({
    name: 'calendarDateChunk',
    standalone: true
})
export class CalendarDateChunkPipe implements PipeTransform {
    transform(calendarDaysArray: ScheduleCalendarDay[], chunkSize: number): ScheduleCalendarDay[][] {
        const calendarDays: ScheduleCalendarDay[][] = [];
        let weekDays: ScheduleCalendarDay[] = [];

        calendarDaysArray.forEach((day: ScheduleCalendarDay, index: number) => {
            weekDays.push(day);

            index = index + 1;
            if (index % chunkSize === 0) {
                calendarDays.push(weekDays);
                weekDays = [];
            }
        });
        return calendarDays;
    }
}
